export default __webpack_public_path__ + "static/media/down-arrow.ed6a38f3.svg";